<template>
    <v-ons-page>
        <!-- Toolbar -->
        <ons-toolbar class="main-toolbar">
            <div class="left">&nbsp;</div>
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="right">
                <ons-toolbar-button>
                    <router-link v-bind:to="{ name: 'Outlets' }" v-bind:title="'Outlets'">
                        <i class="fal fa-times"/>
                    </router-link>
                </ons-toolbar-button>
            </div>
        </ons-toolbar>

        <div class="content">
            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <div class="content-inner" v-if="sale_group != null">

                <div class="verification-container" v-if="sale_group.user && sale_group.user.verified == false">
                    <span v-show="view_order.user.is_guest == false">
                        Please verify your account using the link emailed to you to continue creating orders.
                    </span>
                    <span v-show="view_order.user.is_guest">
                        Please complete your account using the link emailed to you to gain the benefits of a full account.
                    </span>
                    <span class="link-button txt-verification-resend" v-on:click="resendVerificationEmail">I haven't received my email</span>
                </div>

                <div class="sub-header-lite">{{ sale_group.sales.length }} orders from {{ sale_group.outlet.store_display_name }}</div>

                <v-ons-list class="section-h">
                    <v-ons-list-item
                            data-test-id="cnt-order"
                            v-for="order in sale_group.sales"
                            v-bind:key="order.id"
                            v-on:click="$router.push({ name: 'Order', params: { outlet_id: order.outlet.outlet_id, sales_id: order.id } })"
                            modifier="chevron" tapable>
                        <div class="center">
                            <div class="inner-outlet-header">
                                <img v-if="helpers.stringEmpty(order.outlet.logo_image) == false"
                                     class="inner-outlet-header-image"
                                     v-bind:src="order.outlet.logo_image">
                                <div class="inner-outlet-header-container">
                                    <span class="inner-outlet-header-title">{{ order.outlet.store_display_name }}</span>
                                    <span>Order #{{ order.order_ref }}</span>
                                </div>
                            </div>
                            <div class="inner-outlet-header-content">
                                <template v-for="item in order.items">
                                    <span>{{ item.quantity }}x {{ item.product_name }}
                                    </span><br>
                                </template>
                            </div>
                        </div>
                        <div class="right">
                            <span class="order-details-container">
                                <span class="item-price-text">{{ filters.money(order.order_total, true, sale_group.currency_symbol) }}</span>
                            </span>
                        </div>
                    </v-ons-list-item>
                </v-ons-list>

            </div>
        </div>

        <v-ons-alert-dialog
                data-test-id="dlg-order-restored"
                v-bind:visible.sync="show_order_restored_dlg"
                v-bind:footer="{
                    Close: () => this.show_order_restored_dlg = false,
                }"
                title="Restored order">
            <div class="section-h">
                Showing the details for your last order which was interrupted during checkout.
            </div>
        </v-ons-alert-dialog>

    </v-ons-page>

</template>

<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex'

    export default {

        props: [],

        components : {

        },

        created() {

        },

        mounted() {

            this.show_loading = true
            this.app.http.get(`multiorder/${this.$route.params.sale_group_id}`)
                .then(response => {
                    this.show_loading = false
                    this.sale_group = response.data.sale_group

                    if (this.$route.params.in_flight) {
                        this.show_order_restored_dlg = true
                    }
                })
                .catch(error => {
                    this.show_loading = false

                    this.$ons.notification.alert(
                        this.app.getResponseErrorMessage(error),
                        { title: 'Unable to load orders' }
                    )
                })
        },

        data() {
            return {
                app: this.$root.$data.app,
                sale_group: null,
                show_loading: false,
                show_order_restored_dlg: false,
            }
        },

        methods : {

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/js/components/user/multi_order.vue